import { render } from "./road.vue?vue&type=template&id=4c4a1ff1"
import script from "./road.vue?vue&type=script&lang=js"
export * from "./road.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__